enum PAYMENT_METHOD { //Return type to backend
    CASH = 'CASH', //*
    ON_ACCOUNT = 'ON_ACCOUNT', //*
    UNSPECIFIED = 'UNSPECIFIED', //*
}

enum PAYMENT_OPTIONS {
    ON_ACCOUNT_OR_CASH = 'ON_ACCOUNT_OR_CASH',
    CASH = 'CASH',
    ON_ACCOUNT = 'ON_ACCOUNT',
    NOTHING = 'NOTHING'
}

//ENUM FOR ORDER_DATE_DELIVERY
enum ORDER_DATE {
    NOTHING = 'NOTHING',
    DATE = 'DATE',
    DATETIME = 'DATETIME',
}

//ENUM FOR ORDER_DATE_PICKUP
enum ORDER_DATE_PICKUP {
    UNAVAILABLE = 'UNAVAILABLE',
    DATE = 'DATE',
    DATETIME = 'DATETIME'
}

export const LOCATION_TYPE = {
    // Bar / Kneipe
    BAR: 'bar',
    // Büro
    OFFICE: 'office',
    // Café/ Bistro
    COFFEE_SHOP: 'coffeeShop',
    // Caterer / Kantine / Vereine
    CATERER: 'caterer',
    // Club
    CLUB: 'club',
    // Event
    EVENT: 'EVENT',
    // Getränkeabholmarkt
    GETRAENKEABHOLMARKT: 'getraenkeabholmarkt',
    // Getränkehändler
    GETRAENKEHAENDLER: 'getraenkehaendler',
    // Händler
    DEALER: 'DEALER',
    // Hotel
    HOTEL: 'hotel',
    // Imbiss / Kiosk / Take-Away
    TAKE_AWAY: 'takeAway',
    // Restaurant
    RESTAURANT: 'restaurant',
    // Tankstelle / Spätshop
    SPAETSHOP: 'spaetshop',
    // Sternegastronomie
    STAR_GASTRONOMY: 'STAR_GASTRONOMY',
    // Systemgastronomie
    SYSTEM_GASTRONOMY: 'SYSTEM_GASTRONOMY',
    // Diverses Unternehmen
    // OTHER: 'other' // deactivate → ticket 706
} as const

export type LOCATION_TYPE_TYPE = (typeof LOCATION_TYPE)[keyof typeof LOCATION_TYPE]

enum KIND {
    ONLINE = 'ONLINE',
    PRIVATE = 'PRIVATE',
    ADVERTISER = 'ADVERTISER',
    OFFLINE_CHILD = 'OFFLINE_CHILD',
    PRIVATE_PARENT = 'PRIVATE_PARENT',
    OFFLINE_PARENT = 'OFFLINE_PARENT'
}

enum INDUSTRY_TYPE {
    OTHER = 'SONSTIGE',
    DRINK = 'GETRAENKEFACHGROSSHANDEL',
    GROCERY = 'LEBENSMITTEL_GROSSHANDEL',
    GENERAL = 'HANDELSWAREN_ALLGEMEIN',
    PRIVATE = 'PRIVATE'
}

enum CUSTOM_SUPPLIER_TYPE {
    MEAT = 'meat',
    VEGETABLE = 'vegetable',
    DRINKS = 'drinks',
    HYGIENE = 'hygiene',
    OTHER = 'other'
}

enum DELIVERY_DATE_TYPE {
    HOLIDAY = 'HOLIDAY',
    WEEKEND = 'WEEKEND',
    WORKDAY = 'WORKDAY',
    LEAD_TIME = 'LEAD_TIME',
    UNKNOWN = 'UNKNOWN'
}

enum CATALOG_MODE {
    CATALOG = 'catalog',
    SPECIAL_OFFERS = 'specialOffers',
    LIST_CATALOG = 'listCatalog'
}

export enum LINK_TYPE {
    MASTER_CATALOG = 'masterCatalog',
    CATALOG_SEARCH = 'catalogSearch',
}

export {
    ORDER_DATE,
    PAYMENT_METHOD,
    PAYMENT_OPTIONS,
    INDUSTRY_TYPE,
    KIND,
    CUSTOM_SUPPLIER_TYPE,
    ORDER_DATE_PICKUP,
    DELIVERY_DATE_TYPE,
    CATALOG_MODE
}
